require("./bootstrap");
window.Vue = require("vue").default;
import store from "./store";
import Vuetify from "vuetify";
import Vuex from "vuex";
import router from "./router";
import Loading from "vue-loading-overlay";
import ViewUI from "view-design";
import common from "./common";
import VueApexCharts from "vue-apexcharts";
import "vue-datetime/dist/vue-datetime.css";
import { Datetime } from "vue-datetime";
import Vuelidate from "vuelidate";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

// import "../css/form.css";

//import "vuetify/dist/vuetify.min.css";
//import "vue-loading-overlay/dist/vue-loading.css";
//import "view-design/dist/styles/iview.css";
import DatetimePicker from "vuetify-datetime-picker";
import DateRangePicker from "vue2-daterange-picker";
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
import VuePlyr from "vue-plyr";
import "vue-plyr/dist/vue-plyr.css";

Vue.mixin(common);
Vue.use(Vuex);
Vue.use(ViewUI);
Vue.use(Vuetify);
Vue.use(VuePlyr);

Vue.use(DateRangePicker);
Vue.use(Loading);
Vue.use(VueApexCharts);
Vue.component("popper", Popper);

Vue.component("ate-range-picker", DateRangePicker);
Vue.component("datetime", Datetime);
Vue.component("apexchart", VueApexCharts);

Vue.use(require("vue-moment"));
Vue.use(Vuelidate);
Vue.use(VueSweetalert2);

Vue.use(DatetimePicker);
Vue.component("admin-page", () =>
    import("./components/Admin/dashboard/index.vue")
);
Vue.component("login-page", () => import("./components/Auth/login.vue"));

if (process.env.MIX_APP_ENV === "production") {
    Vue.config.devtools = false;
    Vue.config.debug = false;
    Vue.config.silent = true;
}

export default new Vuetify({
    icons: {
        iconfont: "mdiSvg", // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
});

const app = new Vue({
    el: "#app",
    vuetify: new Vuetify(),
    store,
    router,
});
